import * as React from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DatePickerValue(props) {
    const [value, setValue] = React.useState(dayjs(new Date()));
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={props.label + "*"}
                value={value}
                fullWidth
                disablePast
                color="primary"
                sx={{
                    color: "grey", width: "100%", borderColor: 'grey', '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                    }

                }}
                onChange={(newValue) => setValue(newValue)}
            />
        </LocalizationProvider>
    );
}